<template>
  <ancestryline-modal title="protocol.tab-financial.modal-entry.title"  id="add-entry-modal" :close="true" @close="close" :loading="false">

    <card>
      <coff-input-select v-if="typeEntry !== 'DISCOUNT'" v-model="entry.typeEntry" label="protocol.tab-financial.modal-entry.type" class="p-col-12 p-md-3 p-lg-3" :options="typeEntries" option-value="id" :error="validation.typeEntry"/>
      <coff-input-money v-model="entry.valueEntry" label="protocol.tab-financial.modal-entry.value" class="p-col-12 p-md-5 p-lg-3" :error="validation.valueEntry === '0,00'" />
      <coff-input-select v-model="entry.client" label="protocol.tab-financial.modal-entry.client" class="p-col-12 p-md-4 p-lg-6" :options="clientsProtocol" :error="validation.client"/>
      <coff-input-text v-model="entry.observation" label="protocol.tab-financial.observation" class="p-col-12"/>
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <Button :label="$t('btn.save')" @click="save" class="p-ml-auto p-button-success"/>
    </template>
  </ancestryline-modal>
</template>

<script>
import ValidationUtils from "@/utils/ValidationUtils";
import DialogService from "@/business/ModalBusiness";
import { TYPE_ENTRIES } from "@/constants/TypeOfEntry";
import ProtocolBusiness from "@/business/ProtocolBusiness";

export default {
  name: "ModalAddEntry",

  props: ["entry", "protocolId", "typeEntry"],

  data(){
      return {
          typeEntries: TYPE_ENTRIES.filter(item => item.id !== 'DISCOUNT'),
          validation: {
              typeEntry: false,
              valueEntry: false,
              client: false,
          },
          clientsProtocol: [],
      }
  },

  async mounted() {
    const response = await ProtocolBusiness.clientsOfProtocol(this.protocolId);
    this.clientsProtocol = response.map(item => item.client);
  },

  methods: {
    close(){
      DialogService.closeModal();
    },

    save(){
        if (this.typeEntry !== 'DISCOUNT') {
          delete this.validation.client;
        } else {
          this.entry.typeEntry = this.typeEntry;
        }
        this.validation = ValidationUtils.basicValidation(this.validation, this.entry);
        if(!this.validation.erros){
            DialogService.closeModal(this.entry);
        }
    },
  },

}
</script>

<style scoped>

</style>